/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_No_ResultsInputs */

const en_us2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No exercise matches these filters. Try another search or clear the filters.`)
};

const pt_br2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com esses filtros. Tente outra busca ou limpe os filtros.`)
};

const es_419_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio coincide con estos filtros. Prueba otra búsqueda o borra los filtros.`)
};

const pt_pt2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com estes filtros. Experimenta outra pesquisa ou limpa os filtros.`)
};

const fr_fr2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice ne correspond à ces filtres. Essaie une autre recherche ou efface les filtres.`)
};

const de_de2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übung passt zu diesen Filtern. Versuch eine andere Suche oder setz die Filter zurück.`)
};

const it_it2_plan_build_no_results = /** @type {(inputs: Plan_Build_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio con questi filtri. Prova un'altra ricerca o azzera i filtri.`)
};

/**
* | output |
* | --- |
* | "No exercise matches these filters. Try another search or clear the filters." |
*
* @param {Plan_Build_No_ResultsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_no_results = /** @type {((inputs?: Plan_Build_No_ResultsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_No_ResultsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_no_results(inputs)
	if (locale === "es-419") return es_419_plan_build_no_results(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_no_results(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_no_results(inputs)
	if (locale === "de-DE") return de_de2_plan_build_no_results(inputs)
	if (locale === "it-IT") return it_it2_plan_build_no_results(inputs)
	return en_us2_plan_build_no_results(inputs)
});
export { plan_build_no_results as "plan-build.no_results" }